/**
 * --------------------------------------------------
 * ----------- Helper functions for tile ------------
 * --------------------------------------------------
 */

/**
 * Price is valid if number and greater/equal to 0
 */
export const isPriceValid = (price) => typeof price === 'number' && price >= 0

/**
 * Returns Tile/Cell color based on price
 */
export const getTileColor = (price, middle, high, isSelected) => {
  if (isSelected) {
    return 'primary.base'
  }

  if (price < middle && isPriceValid(price)) {
    return 'pricePrimary.light'
  }

  if (price >= high && high > middle) {
    return 'promoSecondary.light'
  }

  // Default case is yellow for both medium + invalid prices
  return 'caution.light'
}

/**
 * Returns hover text based on price
 */
/* istanbul ignore next */
export const getText = (minimumRetailPrice, price, isCheapest) => {
  const priceDiff = Math.ceil(minimumRetailPrice) - Math.ceil(price)

  if (priceDiff > 0) {
    return `${isCheapest ? 'Cheapest!' : ''} Save $${priceDiff}`
  }
  if (priceDiff < 0) {
    return `+ $${-priceDiff}`
  }
  return ''
}

/**
 * Update the dates in the URL when clicking a tile
 */
/* istanbul ignore next */
export const updateURL = (url, day) => {
  let newURL

  if (day) {
    let [departDate, returnDate] = url.match(/\d+/gm).slice(0, 2)
    let firstReplace = url.replace(departDate, day?.departDate?.split('-').join(''))

    // Problem here is - if date's the same, it'll replace first date
    // Workaround is to omit contents before index 58, where 2nd date starts
    let re = new RegExp(returnDate, 'g')
    newURL = firstReplace.replace(re, (substr, i) => (i > 58 ? day?.returnDate.split('-').join('') : substr))
  }
  return newURL
}

/**
 * Open a new tab upon clicking a tile (with new dates)
 */
/* istanbul ignore next */
export const handleClick = (price, url, day) => {
  if (isPriceValid(price)) {
    window.open(updateURL(url, day), '_blank')
  }
}
